import { Dispatch, SetStateAction, useCallback, useContext } from "react";
import { NumberOfferContext } from "../../../App";
import { ICart, ICartOffer } from "../ICart";
import { getCartItemsNumber } from "@utils/getCartItemsNumber";
import { useFetchState } from "@hooks/useFetchState";
import { deleteOffer } from "@modules/eirSalesFacade/apis/deleteOffer";
import { sendRemoveCartEvent } from "@features/dataLayer/removeCart";

interface IParams {
    setCart: Dispatch<SetStateAction<ICart | undefined>>;
}

export const useDeleteOffer = (props: IParams) => {
    const { setCart } = props;
    const { startFetching, endFetching, isLoading, error } = useFetchState();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const handleDeleteOffer = useCallback(
        async (offerToDelete: ICartOffer) => {
            try {
                startFetching();

                const newCart = await deleteOffer(offerToDelete.offerId);

                setNumberOfferSelected(getCartItemsNumber(newCart));
                setCart(newCart);
                sendRemoveCartEvent(newCart, offerToDelete);
                endFetching();

                return newCart;
            } catch (apiError) {
                endFetching(apiError);

                return undefined;
            }
        },
        [startFetching, endFetching, setNumberOfferSelected, setCart]
    );

    return { error, handleDeleteOffer, isLoading };
};
